import axiosClient from "../../../config/axios";

const sendReports = async (reportType, emails, token) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    };
    const response = await axiosClient.post('/operative-reports/operative-report', {emails, reportType}, {headers});
    return response;
  } catch (error) {
    return error;
  }
}

export {
  sendReports,
}